import React, { useState, useEffect, useRef, Fragment } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from "react-loading-skeleton";
import axiosInstance from "./../../helpers/axiosInstance";
import MyModal from "components/Modal/Modal";
import santander from '../../assets/img/brand/santander.png';
import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';

import Checksantader from "./Checksantander";
import Compotp from "./Compotp";


// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Modal,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { normalizeUnits } from "moment";
import { tr } from "date-fns/locale";
import basePerfiles from "./basePerfiles.js";
import baseUsuarios from "./baseUsu.js";
import { set } from "date-fns";
import baseTransaccionPen from "./baseTransaccionesPen.js";
import IconNid from '../../assets/img/icons/Icono-Numero-documento-Gris.png';
import IconCorreo from '../../assets/img/icons/Icono-Correo-Gris.png';
import IconNom from '../../assets/img/icons/Cliente-Gris2x.png';
import IconCel from '../../assets/img/icons/Telefono-Gris2x.png';
import IconPesos from '../../assets/img/icons/Tope_Monto_Transaccional-Gris2x.png';
import IconTid from '../../assets/img/icons/Icono-Tipo-de-documento-Gris.png';
import Campoformato from "./campoformato";
import BotonEliminaIp from "./botoneliminarIp";

const _=require("lodash");

const ComponentemodificaUsu2=(props)=>{
    const listStepLine = [
      { title: "Cliente" },
      { title: "Perfil" },
      { title: "Supervisor" },

      {title:"Ip"},
    ];
    
    const [descripLineaCreacion,setdescripLineaCreacion]=useState([
      "En este espacio podrás crear o registrar un nuevo usuario. Recuerda diligenciar todos los campos y casillas.",
      "Personaliza los permisos que tendrá este nuevo usuario.",
      "Podrás registrar máximo 5 direcciones IP. Recuerda, si no ingresas ninguna IP, el usuario podrá acceder a la banca virtual sin ninguna restricción.",
      "En esta sección podrás seleccionar un usuario supervisor."
    ]);
    const [etapaModif,setetapaModif]=useState(0);
    const [infUsuModif,setinfUsuModif]=useState(props.infUsuM);
    const [indicadoretapa,setindicadoretapa]=useState(0);
    const [Ips,setIps]=useState(props.infUsuM.listIp);
    const [IpAct,setIpAct]=useState("");
    const refModifNombre=useRef(null);
    const maxdiario=useRef(null);
    const maxtransa=useRef(null);
    const [perfiles,setperfiles]=useState(basePerfiles);
    const [perfiluser,setperfiluser]=useState(props.infUsuM.profileUser);
    const [listAlert, setListAlert] = useState([]);
    const [listProducts, setlistProducts] = useState([]);
    const [clasestarjetasprodorig,setclasestarjetasprodorig]=useState([]);
    const [OpcProdSelec,setOpcProdSelec]=useState(-1);
    const [productState,setproductState]=useState({
      accountSystem:"",
      accountNumber:"",
      description:"",
      action:"",
      validation:"",
      minValue:"",
      maxValue:"",
      maxTransaction:"",
      maxDaily:""
    });
    const [maxDaily,setmaxDaily]=useState("");
    const [maxTransaccional,setmaxTransaccional]=useState("");
    const [topesMax,settopesMax]=useState("");
    const [productosatados,setproductosatados]=useState([]);
    const [topeMD,settopeMD]=useState(1);
    const [otpmodifusu,setotpmodifusu]=useState(false);
    const [cargandootpmodifusu,setcargandootpmodifusu]=useState(true);
    const [idtransfer,setidtransfer]=useState("");
    const [otpdigitada,setotpdigitada]=useState("");
    const [productoscheck,setproductoscheck]=useState([]);
    const [exitoModif,setexitoModif]=useState(false);
    const [tiduser,settiduser]=useState("");
    const [bodyprodedit,setbodyprodedit]=useState({
      maxDaily:"",
      maxTransaction:"",
      otp:false,
      supervisor:false,
      consulta:false,
      transaccion:false
    });
    const [supervisorUsers, setSupervisorUsers] = useState([]);

    const getCookie = (name) => {
      let matches = document.cookie.match(
        new RegExp(
          "(?:^|; )" +
            name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
            "=([^;]*)"
        )
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    };

    const controlesCreaUsu=(etapa,sentido)=>{
      if(sentido==1){
        if(etapa+1 <= 3 && etapa>=0){
          setindicadoretapa(etapa+1);
        }
      }else{
        if(etapa-1 >=0){
          setindicadoretapa(etapa-1);
        }
      }
    }

    var createReactClass = require("create-react-class");


    useEffect(()=>{
      let estadosperfil=_.cloneDeep(perfiles);
      let cadenaperfil=props.infUsuM.profileUser;
      for(let i=0;i<estadosperfil.length;i++){
        // if(cadenaperfil.substr(i,1)==1){
        //   estadosperfil[i].habilitado=true;
        // }else{
        //   estadosperfil[i].habilitado=false;
        // }
        if(cadenaperfil == estadosperfil[i].value){
              estadosperfil[i].habilitado=true;
            }else{
              estadosperfil[i].habilitado=false;
          }
      }
      setperfiles(_.cloneDeep(estadosperfil));
      switch(props.infUsuM.tidUser){
        case "1":
          settiduser("Cédula de Ciudadanía");
          break;
        case "2":
          settiduser("Tarjeta de Identidad");
          break;
        case "3":
          settiduser("NIT");
          break;
        case "5":
          settiduser("Pasaporte");
          break;
        case "6":
          settiduser("Carnet Diplomático");
          break;
        case "8":
          settiduser("Fideicomiso");
          break;
        case "9":
          settiduser("Registro Civil de Nacimiento");
          break;
        
      }
      console.log("carga useEffect");
    },[]);
    const validaIp=(ipvalor)=>{
      let valor="";
      let rango=0;
      let ipvalido=true;
      let ipajustada="";
      try{
        if(ipvalor.length>0){
          for(let i=0;i<ipvalor.length;i++){
            if(ipvalor.substr(i,1)=="."){
              rango++;
              if(parseInt(valor)>=0 && parseInt(valor)<256){
                console.log(parseInt(valor));
                ipajustada=ipajustada + parseInt(valor) + "."
  
              }else{
                ipvalido=false;
                console.log("error en el rango " + rango);
              }  
              valor=""
            }else if(i==ipvalor.length-1){
              valor= valor + ipvalor.substr(i,1) + ""
              rango++;
              if(parseInt(valor)>=0 && parseInt(valor)<256){
                console.log(parseInt(valor));
                ipajustada=ipajustada + parseInt(valor)
              }else{
                ipvalido=false;
                console.log("error en el rango " + rango);
              }
            }else{
              valor= valor + ipvalor.substr(i,1) + ""
            }
          }
        }
        if(rango!=4){
          ipvalido=false;
        }
        if(ipvalido){
          return {valida:ipvalido, IpAjustada:ipajustada}
        }else{
          return {valida:false, IpAjustada:""}
        }
        
      }catch{
        console.log("error en la ip");
        return {valida:false, IpAjustada:""}
      }
    }
    const editanombre=(event)=>{
        event.preventDefault();
        setinfUsuModif({...infUsuModif,nameUser:event.target.value});
    
        console.log(infUsuModif);
        refModifNombre.current.focus();
      }
    const editacorreo=(event)=>{
      event.preventDefault();
      setinfUsuModif({...infUsuModif,emailUser:event.target.value});
  
      console.log(infUsuModif);

    }
    const editacelular=(event)=>{
      event.preventDefault();
      setinfUsuModif({...infUsuModif,cellNumberUser:event.target.value});
  
      console.log(infUsuModif);

    }
    const enviacancelacionM=()=>{
      console.log("envia cancela modificacion");
      props.cancelaMU("modifica");
    }

    const actualizaUsuario=async(otpdig)=>{
      setindicadoretapa(10);
      let usuariomodificado={
        TidCompany: getCookie("tid"),
        NidCompany: getCookie("nid"),
        TidUser: infUsuModif.tidUser,
        NidUser: infUsuModif.nidUser,
        NameUser:infUsuModif.nameUser ,
        EmailUser: infUsuModif.emailUser,
        CellNumberUser: infUsuModif.cellNumberUser,
        AgencyUser: "",
        TypeUser: "4",
        PasswordConditionUser: "021",
        StatusUser: "1",
        SupervisorCode: infUsuModif.supervisorCode,
        ProfileUser: perfiluser,
        IsSupervisorUser: infUsuModif.isSupervisorUser,
        ListIp:Ips,
        UniqueIdUser:infUsuModif.uniqueIdUser,
        idTransfer: idtransfer,
        otp: otpdig
      }
      console.log("cuerpo de actualizacion de usuario");
      console.log(usuariomodificado);
      const request = await axiosInstance().post(
          "/WSGYG39_2/api/Inquiries/UpdateUser",
          usuariomodificado
        )
        .catch((err) => {
          console.log("error en la modificacion");
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );
          } else {
            setListAlert([
              {
                description: "Clave temporal incorrecta",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
          }
          setotpmodifusu(false);
          setindicadoretapa(3);
          
          return "err";
        });
      if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
        console.log(request);
        setlistProducts(request.data.productsUser);
        setotpdigitada(otpdig);
        console.log(listProducts);
        let atados=[];
        let checXprod=[];
        for(let i=0;i<request.data.productsUser.length;i++){
          if(request.data.productsUser[i].maxTransaction.length>0){
            atados.push(i);
            checXprod.push(true);
          }else{
            checXprod.push(false);
          }
        }
        setproductosatados([...atados]);
        setproductoscheck([...checXprod]);
        setindicadoretapa(10);
        setotpmodifusu(false);
        setexitoModif(true);
        //setindicadoretapa(10);
        //props.cancelaMU("modifica");
        //setTabs(0);
      }
      //let n=indicadoretapa;
      //setindicadoretapa(n++);
    }
    const nextinfbasic=()=>{
      let n=indicadoretapa;
      n++;
      setindicadoretapa(n);
      console.log(indicadoretapa);
    }
    const editaIp=(event)=>{
      event.preventDefault();
      setIpAct(event.target.value);
      console.log(IpAct);
  
    }
    // function getSupervisor(tab ,index) {
    //   //await setProductOne(supervisor);
    //   let copiaclasprod=[...clasestarjetasprodorig];
    //   copiaclasprod[index]="mb-xl-0 cursor-pointer bordeHover productoselec";
    //   setclasestarjetasprodorig([...copiaclasprod]);
    //   console.log("tab" + tab)
    //   //getRelatedAccounts(product.accountNumber);
    //   //await AvanzaStep(2);
    // }
    const finEdtIps=async()=>{
      infUsuModif.ListIp=[...Ips];
      console.log("infUsuModif");
      console.log(infUsuModif);
      if(infUsuModif.isSupervisorUser=="N"){
        // setStepLine((s) => s + 1);
        // setmaxstepcreaUsu((s) => s + 1);
        const request = await axiosInstance()
          .get(
            "/WSGYG39_2/api/Inquiries/GetSupervisorUsers"
          )
          .catch((err) => {
            console.log("error en getProfile");
            console.log(err);
            return "err";
          });
        if (request != "err") {
          console.log("res getprofile");
          console.log(request.data);
          setSupervisorUsers(request.data);  
        }
      }else{
        /*
        console.log("Usuario a crear");
        console.log(newUser);
        const request = await axiosInstance()
          .post("/WSGYG39_2/api/Inquiries/CreateUser", newUser)
          .catch((err) => {
            return "err";
          });
        if (request != "err") {
          console.log("respuesta creacion de usuarios")
          console.log(request.data);
          setListProducts(request.data.productsUser);
          setUniqueIdUser(request.data.uniqueIdUser);
          setStepLine((s) => s + 2);
        }
        */
        // setStepLine((s) => s + 2);
        // setmaxstepcreaUsu((s) => s + 2);
        let n=indicadoretapa;
        console.log("valor de n");
        console.log(n);
        n = n + 2;
        setindicadoretapa(n);
      }
    }
    var RelatedAccounts = createReactClass({
      render: function () {
        var data = this.props.data;
        var newsTemplate;
        var tab = this.props.tab;
        if (data.length > 0) {
          var infoSuperCode = infUsuModif.supervisorCode; 
          infoSuperCode =  infoSuperCode.replaceAll(' ','');
          newsTemplate = data.map(function (item, index) {
            if(infoSuperCode == item.code){
              //getSupervisor(item, tab, index, 1);
              return (
              
                <Row key={index} onClick={() => getSupervisor(item, tab, index)}>
                  <RelatedAccount data={item} claseprod="mb-xl-0 cursor-pointer bordeHover productoselec"/>
                </Row>
              );
             }else{
                  return (
                    
                    <Row key={index} onClick={() => getSupervisor(item, tab, index)}>
                      <RelatedAccount data={item} claseprod={clasestarjetasprodorig[index]}/>
                    </Row>
                  );
             }
          });
        } else {
          newsTemplate = (
            <Skeleton
              height={100}
              count={5}
              className="card-transaction-info"
              style={{ width: "-webkit-fill-available" }}
            ></Skeleton>
          );
        }
        return <div>{newsTemplate}</div>;
      },
    });
    var RelatedAccount = createReactClass({
      render: function () {
        //var ownerAccount = this.props.data.ownerAccount;
        var ownerAccount = this.props.data.name;
        return (
          <Col lg="12" xl="12" className="pt-3">
            <Card className={this.props.claseprod}>
             <CardBody className="p-2 cursor-pointer bordeHover">
              <div className="row" style={{ padding: "1rem" }}>
                <div className="col-auto mr-3">
                  <GetInitial contact={ownerAccount}></GetInitial>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <span class="mb-0 text-sm">{ownerAccount}</span>
                </div>
              </div>
              </CardBody>
            </Card>
          </Col>
        );
      },
    });
    async function getSupervisor(supervisor, tab, index) {
      console.log("Usuario a crear: " + infUsuModif.supervisorCode);
      infUsuModif.supervisorCode = supervisor.code;
      setinfUsuModif({...infUsuModif,supervisorCode:supervisor.code});
      console.log(infUsuModif);

      let copiaclasprod=[...clasestarjetasprodorig];
      copiaclasprod[index]="mb-xl-0 cursor-pointer bordeHover productoselec";
      setclasestarjetasprodorig([...copiaclasprod]);
      console.log("tab" + tab)
      /*
      const request = await axiosInstance()
        .post("/WSGYG39_2/api/Inquiries/CreateUser", newUser)
        .catch((err) => {
          return "err";
        });
      if (request != "err") {
        console.log("respuesta creacion de usuarios")
        console.log(request.data.productsUser);
        setListProducts(request.data.productsUser);
        setUniqueIdUser(request.data.uniqueIdUser);
        setStepLine((s) => s + 1);
      }
      */
      // setStepLine((s) => s + 1);
      // setmaxstepcreaUsu((s) => s + 1);
     
        let n=indicadoretapa;
        n++;
        setindicadoretapa(n);
      
      
    }
    const GetInitial = (props) => {
      if (props.contact !== null) {
        var initial = props.contact.substr(0, 1);
        return (
          <div class="icon icon-shape bg-green text-white rounded-circle shadow">
            {initial}
          </div>
        );
      } else return "";
    };
  
    const agregaIp=()=>{
      if(Ips.length<5){

        const IpValida=validaIp(IpAct)
        if(IpValida.valida){
          let listaIps=[...Ips];
          listaIps.push(IpValida.IpAjustada);
          setIps([...listaIps]);
          setIpAct("");
        }else{
          setListAlert([
            {
              description: "Ip invalida.Debe ser (0-255).(0-255).(0-255).(0-255) Ejemplo: 102.10.204.31",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
          setTimeout(deleteElementFromArr, 5000);
        }
      }
      
    }
    const eliminaIp=(index)=>{
      if(index<Ips.length){
        let listaIps=[...Ips];
        listaIps.splice(index,1);
        setIps([...listaIps]);
      }
    }
   
    const escuchaCheck= (idCheck,estado)=>{
    
      let estadoperfiles=_.cloneDeep(perfiles);
      if(perfiles.length>0){
        for(let i=0;i<perfiles.length;i++){
          if(perfiles[i].id==idCheck){
            estadoperfiles[i].habilitado=estado;
            //i=perfiles.length;
          }else{
            estadoperfiles[i].habilitado=false;
            //i=perfiles.length;
          }
        }
        setperfiles(_.cloneDeep(estadoperfiles));
        
        
      }
      console.log(perfiles);
      console.log("Check " + idCheck + " estado " + estado);
    }
    const getProfile=()=>{
      console.log("guarda permisos");
      console.log(perfiles);
      let buildperfil="";
      if(perfiles.length>0){
        for(let i=0;i<perfiles.length;i++){
          if(perfiles[i].habilitado){
            buildperfil = perfiles[i].value;
          }
        }
      }
      setperfiluser(buildperfil);
      let n=indicadoretapa;
      n++;
      setindicadoretapa(n);
    }
    // const deleteElementFromArr = () => {
    //   console.log("tarea automatica");
    //   console.log(listAlert);
    //   if (listAlert.length > 0) {
    //     let temp = listAlert.slice();
        
    //     temp.splice(0, 1);
    //     setListAlert(temp);
    //   }
    // };
    useEffect(async() => {
    
    
      const timer = setTimeout(deleteElementFromArr, 5000);
      return () => clearTimeout(timer);
    });
    
    const deleteElementFromArr = () => {
      
      if (listAlert.length > 0) {
        let temp = listAlert.slice();
        temp.splice(0, 1);
        setListAlert(temp);
      }
    };
    const deleteAlert = (alert) => {
      setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
    };
    const enmascara=(cadena)=>{
      let n=cadena.length;
      let vista=n-4;
      let salida=""
      if(vista>=0){
          for(let i=0;i<n;i++){
              if(i>=vista){
                  salida=salida + cadena.substr(i,1);
              }else{
                  salida=salida + "*"
              }
          }
      }
      return salida;
    }
    var createReactClass = require("create-react-class");
    var Alerts = createReactClass({
      render: function () {
        var data = this.props.data;
        var newsTemplate;
        if (data.length > 0) {
          newsTemplate = data.map(function (item, index) {
            return (
              <div class={item.type} role="alert">
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  onClick={() => deleteAlert(item)}
                >
                  <span aria-hidden="true">×</span>
                </button>
                <span className="alert-inner--icon mr-3">
                  <i className={item.icon} />
                </span>{" "}
                <span class="alert-inner--text">{item.description}</span>
              </div>
            );
          });
        }
        return <div className="toast-bottom-right">{newsTemplate}</div>;
      },
    });

    const CardAccount = (props)=>{
      let accountNumber =enmascara(props.data.accountNumber);
      let description = props.data.description;
      let selectProduct =false;
      console.log("Cuenta " + props.data.accountNumber);
      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card  className="mb-xl-0 cursor-pointer bordeHover" >
            
               <CardBody className="p-2">
                 <Row>
                     <div onClick={()=>getProduct(props.data,props.index)} className="col-auto ml-4 p-1" style={{ width: "300px" }}>
                        <Row>
                            <span class="mb-0">
                              {description} <br /> No. {accountNumber}
                            </span>
                            
                          </Row>
                      </div>
                      <div className="ml-3">
                         <Checksantader mensaje={""} estadocheck={productoscheck[props.index]} idCheck={props.index} funcionpadre={escuchaprodselec}></Checksantader>
                      </div>
                 </Row>
                </CardBody>
              
          </Card>
      </Col>
      );
    }
    const getProduct=async(product,index)=>{
      if(OpcProdSelec<0){
        console.log(product);
        await setproductState(product);
        await setmaxDaily(product.maxDaily);
        await setmaxTransaccional(product.maxTransaction);
        setOpcProdSelec(index);
        setmaxDaily(product.maxDaily);
        setmaxTransaccional(product.maxTransaction);
        settopesMax(product.maxDaily);
        let cuerpomodifprodPopUp={
          maxDaily:product.maxDaily,
          maxTransaction:product.maxTransaction,
          otp:false,
          supervisor:false,
          consulta:false,
          transaccion:false

        }
        /*
        setbodyprodedit({...bodyprodedit,maxDaily:product.maxDaily});
        setbodyprodedit({...bodyprodedit, maxTransaction:product.maxTransaction});
        setbodyprodedit({...bodyprodedit,otp:false});
        setbodyprodedit({...bodyprodedit,supervisor:false});
        setbodyprodedit({...bodyprodedit,consulta:false});
        setbodyprodedit({...bodyprodedit,transaccion:false});
        */
        if(product.validation=="N"){
          
          cuerpomodifprodPopUp.otp=true;

        }
        if(product.validation=="S"){
           
          cuerpomodifprodPopUp.supervisor=true;
        }
        if(product.action=="C"){
          
          cuerpomodifprodPopUp.consulta=true;
        }
        if(product.action=="T"){
          
          cuerpomodifprodPopUp.transaccion=true;
        }
        setbodyprodedit(JSON.parse(JSON.stringify(cuerpomodifprodPopUp)));
        setindicadoretapa(6);
      }
    }
    const finproducto=()=>{
      setproductState(
      {
        accountSystem:"",
        accountNumber:"",
        description:"",
        action:"",
        validation:"",
        minValue:"",
        maxValue:"",
        maxTransaction:"",
        maxDaily:""
      })
      setOpcProdSelec(-1);
      setmaxDaily("");
      setmaxTransaccional("");
      settopesMax("");

      setindicadoretapa(4);
    }
    const salirModifProdPopUp=()=>{
      setOpcProdSelec(-1);
      setindicadoretapa(5);
    }
    const saliryguardarmodifPopUp=(modificacionPopUp)=>{
      let copialistaproduc=_.cloneDeep(listProducts);
      copialistaproduc[OpcProdSelec].maxDaily=modificacionPopUp.maxDaily;
      copialistaproduc[OpcProdSelec].maxTransaction=modificacionPopUp.maxTransaction;
      
      if(modificacionPopUp.otp){
        copialistaproduc[OpcProdSelec].validation="N";
      }
      if(modificacionPopUp.supervisor){
        copialistaproduc[OpcProdSelec].validation="S";
      }
      if(modificacionPopUp.consulta){
        copialistaproduc[OpcProdSelec].action="C";
      }
      if(modificacionPopUp.transaccion){
        copialistaproduc[OpcProdSelec].action="T";
      }
      
      console.log("copialistaproduc[OpcProdSelec]");
      console.log(copialistaproduc[OpcProdSelec]);
      setlistProducts(_.cloneDeep(copialistaproduc));
      /*
      let bodyprodModificado={
        accountNumber: copialistaproduc[OpcProdSelec].accountNumber,
        accountSystem: copialistaproduc[OpcProdSelec].accountSystem,
        action: "T",
        description: copialistaproduc[OpcProdSelec].description,
        maxDaily: modificacionPopUp.maxDaily,
        maxTransaction: modificacionPopUp.maxTransaction,
        maxValue: null,
        minValue: null,
        validation: "S",
        }
      */
      let checs=[...productoscheck];
      checs[OpcProdSelec]=true;
      setproductoscheck([...checs]);
      let atados=[...productosatados];

      if(atados.indexOf(OpcProdSelec)<0 && OpcProdSelec>=0){
        console.log("ato el producto " + OpcProdSelec);
        atados.push(OpcProdSelec);

        setproductosatados([...atados]);
      }
      
      setOpcProdSelec(-1);
      setindicadoretapa(5);
    }

    const guardamodifproduct=()=>{
      let copialistaproduc=_.cloneDeep(listProducts);
      copialistaproduc[OpcProdSelec]=JSON.parse(JSON.stringify(productState));
      console.log("productState")
      console.log(productState);
      setlistProducts(_.cloneDeep(copialistaproduc));

      let checs=[...productoscheck];
      checs[OpcProdSelec]=true;
      setproductoscheck([...checs]);
      let atados=[...productosatados];

      if(atados.indexOf(OpcProdSelec)<0 && OpcProdSelec>=0){
        console.log("ato el producto " + OpcProdSelec);
        atados.push(OpcProdSelec);

        setproductosatados([...atados]);
      }
      setOpcProdSelec(-1);
      setindicadoretapa(4);
    }
    const escuchaprodselec=(idprod,estado)=>{
      console.log("La cuenta " + idprod + " esta en " + estado);
      let copiachecks=[...productoscheck];
      copiachecks[idprod]=estado;
      setproductoscheck([...copiachecks]);
      console.log(productoscheck);
    }
        
     
    const OptionsProducts=()=> {
    
      if (OpcProdSelec>=0) {
        
        return (
          <div style={{width:"315px"}}>
            <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                  <button className="btn-icon bg-white text-green btn" onClick={enviacancelacionM}>Cancelar</button>
            </div>
            
            <h2 class="mt-2"> Tipo de Acceso </h2>
            <Row className="m-lg-2 m-xs-0 m-md-0">
              <div
                className={classnames(
                  "radius-left p-1 mt-2 mb-2 text-center text-medium-grey cursor-pointer col",
                  {
                    active: productState.action === "C",
                  }
                )}
                onClick={() => {
                  
                  setproductState({...productState,action:"C"});
                }}
              >
                Consulta
              </div>
              <div
                className={classnames(
                  "radius-right p-1 mt-2 mb-2 text-center text-medium-grey cursor-pointer col",
                  {
                    active: productState.action === "T",
                  }
                )}
                onClick={() => {
                  setproductState({...productState,action:"T"});
                }}
              >
                Transacción
              </div>
            </Row>
            <h2 class="mt-2"> Tipo de Validación </h2>
            <Row className="m-lg-2 m-xs-0 m-md-0">
              <div
                className={classnames(
                  "radius-left p-1 mt-2 mb-2 text-center text-medium-grey cursor-pointer col",
                  {
                    active: productState.validation === "N",
                  }
                )}
                onClick={() => {
                  
                  setproductState({...productState,validation:"N"});
                }}
              >
                OTP
              </div>
              <div
                className={classnames(
                  "radius-right p-1 mt-2 mb-2 text-center text-medium-grey cursor-pointer col",
                  {
                    active: productState.validation === "S",
                  }
                )}
                onClick={() => {
                  setproductState({...productState,validation:"S"});
                }}
              >
                Supervisor
              </div>
            </Row>
          
            <Row className="m-lg-2 m-xs-0 m-md-0">
              <div
                style={{width:"50%"}}
                className={classnames(
                  "radius-left mt-2 mb-2 text-center text-medium-grey cursor-pointer col h-7 p-2",
                  {
                    active: topeMD === 1,
                  }
                )}
                onClick={() => {
                  selectope(1);
                }}
              >
                Tope Monto Transaccional
              </div>
              <div
                style={{width:"50%"}}
                className={classnames(
                  "radius-right mt-2 mb-2 text-center text-medium-grey cursor-pointer col h-7 p-2",
                  {
                    active: topeMD === 2,
                  }
                )}
                onClick={() => {
                  selectope(2)
                }}
              >
                Tope Diario    Transaccional
              </div>
            </Row>
            
            <InputGroup className="input-group-alternative mt-2 mb-2">    
              <div className="inputs-icons-borderbott">
                <input
                  className="form-control h5 p-1"
                  placeholder="Tope Diario Transaccional"
                  type="text"
                  onChange={handleChangeMaximunDaily}
                  value={topesMax}
                  ref={maxdiario}
                  style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                  autoFocus
                />
                <img style={{height:"12px", }} src={IconPesos}></img>
                
              </div>  
            </InputGroup>
  
            <div style={{display:"flex",justifyContent:"center",alignItems:"center", width:"100%"}}>
              <button onClick={guardamodifproduct} className="btn bg-green text-white mb-3">Guardar</button>
              <button onClick={finproducto} className="btn bg-green text-white mb-3">Cancelar</button>
            </div>
            
          </div>
        );
      } else{
        return(
          <div>
  
          </div>
        );
      }
    }
    const handleChangeMaximunDaily =(event) => {
      //settopesxprod({...topesxprod, maxDaily: event.target.value});
      event.preventDefault();
      
      let val = event.target.value;
      settopesMax(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
      if(topeMD==1){
        setmaxDaily(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")); 
        setproductState({...productState,maxDaily:val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")});
      }else{
        setmaxTransaccional(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        setproductState({...productState,maxTransaction:val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")});
      }
      maxdiario.current.focus();
    }
    const selectope=(elec)=>{
      if(elec==1){
        settopesMax(maxDaily);
        settopeMD(1);
      }else{
        settopesMax(maxTransaccional);
        settopeMD(2);

      }
    }
    const handleChangeMaximunTransaction =(event) => {
      //settopesxprod({...topesxprod, maxDaily: event.target.value});
      event.preventDefault();
      let val = event.target.value;
      setmaxTransaccional(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")); 
      maxtransa.current.focus(); 
    }
    const elecModProd=(elec)=>{
      if(elec){
        console.log(listProducts);
        setindicadoretapa(5);
      }else{
        console.log("ingresa al modal de exito")
        setexitoModif(true);
        setindicadoretapa(10);
        //props.cancelaMU("modifica",infUsuModif);
      }
    }
    const pideotpmodif=async()=>{
      setotpmodifusu(true);
      setindicadoretapa(10);
      console.log("mustra modal " + otpmodifusu);
      
      let bodyotp={
        UniqueIdUser:infUsuModif.uniqueIdUser
       }
      console.log("uniqueIdUser: " + bodyotp.UniqueIdUser);
      const request =await axiosInstance().post("/WSGYG39_2/api/Inquiries/GenerateOTP",bodyotp)
        .catch((err) => {
          console.log(err);
          return "err";
        });
      if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
        console.log(request);
        setidtransfer(request.data.idTransfer);
        setcargandootpmodifusu(false);
        setindicadoretapa(3);
      }
    }
    const respuestaotpmodifusu=async(otprecibido)=>{
    
      if(otprecibido.length>0){
        console.log("padre :" + otprecibido);
        setcargandootpmodifusu(true);
        await actualizaUsuario(otprecibido);
      }
  
    }
    const actualizaUsuarioProd=async()=>{
      setindicadoretapa(10);
      let productosAmodif=[];
      console.log("ProductosAtados con length");
      console.log(productosatados.length);
      console.log("ProductosCheck");
      console.log(productoscheck)
      let alertaprod=false;
      let alertausu="";
      let contadorProductos = 0;
      for(let i=0;i<listProducts.length;i++){
        //alertaprod=false;
        if(productoscheck[i]){
          contadorProductos++;
          if(listProducts[i].action != ""){
          }else{
            alertaprod = true;
            alertausu=alertausu + " debe tener una opcion de validacion seleccionada, "; 
          }
          if(listProducts[i].validation != ""){
          }else{
            alertaprod = true;
            alertausu=alertausu + " debe tener una opcion de acción seleccionada, ";
          }
          if (alertaprod == true) {
              setListAlert([
              {
                description: alertausu,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
            setindicadoretapa(5);
          }else{
            
            if(productoscheck[i]){
              productosAmodif.push(JSON.parse(JSON.stringify(listProducts[i])) )
            }
            } 
        }
    }
    if (contadorProductos == 0) {
      setListAlert([
      {
        description: "Debe seleccionar por lo menos un producto",
        type: "alert alert-alert show alert-dismissible fade alert-danger",
        icon: "fas fa-exclamation-circle"
      }
    ]);
    setindicadoretapa(5);
   }
      if(alertaprod == false && contadorProductos != 0){
      let usuariomodificado={
        uniqueIdUser: infUsuModif.uniqueIdUser,
        idTransfer: idtransfer,
        otp: otpdigitada,
        productsUser:_.cloneDeep(productosAmodif)
      }
      console.log("cuerpo de actualizacion de productos");
      console.log(usuariomodificado);
      const request = await axiosInstance().post(
          "/WSGYG39_2/api/Inquiries/UpdateUserProducts",
          usuariomodificado
        )
        .catch((err) => {
          console.log("error en la modificacion");
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );
          } else {
            setListAlert([
              {
                description: "No se pudo realizar la modificacion de los productos.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
          }
          
          
          setindicadoretapa(5);
          
          return "err";
        });
      if (request != "err") {//agregar mensaje de exito dependiendo respuesta 
        console.log(request);
        setListAlert([
          {
            description: "Modificacion realizada con exito.",
            type: "alert alert-alert show alert-dismissible fade alert-success",
            icon: "fas fa-check-circle",
          },
        ]);
        
        setotpmodifusu(false);
        setexitoModif(true);
        //props.cancelaMU("modifica");
        //setTabs(0);

    }
  }
      //let n=indicadoretapa;
      //setindicadoretapa(n++);
    }
    const terminaModifProd=()=>{
      props.cancelaMU("modifica",infUsuModif);
    }

    switch(indicadoretapa){
      case 0:
        return(
          <Col xl="6" lg="8">
              <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                  <button className="btn-icon bg-white text-green btn" onClick={enviacancelacionM}>Cancelar</button>
              </div>
              <div style={{display:"flex",flexDirection:"row", justifyContent:"space-between",alignItems:"center"}}>
                <button onClick={()=>{controlesCreaUsu(indicadoretapa,-1)}} className="btn-icon text-dark-grey btn"><span class="btn-inner--icon">{"<"}</span>Volver</button>
                <button onClick={()=>{controlesCreaUsu(indicadoretapa,1)}} className="btn-icon text-dark-grey btn">Siguiente{" "}<span class="btn-inner--icon">{">"}</span></button>
              </div>
              {/*
              <Row className="m-lg-1 m-xs-0 m-md-0" style={{height:"70px"}}>
                  <div
                      className={classnames(
                      "radius-left p-3 mt-4 mb-4 text-center text-medium-grey cursor-pointer col h6",
                      {
                          active: infUsuModif.tidUser === "1",
                      }
                      )}
                  >
                      CC
                  </div>
                  <div
                      className={classnames(
                      "radius-middle p-3 mt-4 mb-4 text-center text-medium-grey cursor-pointer col h6",
                      {
                          active: infUsuModif.tidUser === "2",
                      }
                      )}
                      
                  >
                      CE
                  </div>
                  <div
                      className={classnames(
                      "radius-middle p-3 mt-4 mb-4 text-center text-medium-grey cursor-pointer col h6",
                      {
                          active: infUsuModif.tidUser === "3",
                      }
                      )}
                      
                  >
                      NIT
                  </div>
                  <div
                      className={classnames(
                      "radius-middle p-3 mt-4 mb-4 text-center text-medium-grey cursor-pointer col h6",
                      {
                          active: infUsuModif.tidUser === "4",
                      }
                      )}
                      
                  >
                      TI
                  </div>
                  <div
                      className={classnames(
                      "radius-middle p-3 mt-4 mb-4 text-center text-medium-grey cursor-pointer col h6",
                      {
                          active: infUsuModif.tidUser === "5",
                      }
                      )}
                      
                  >
                      PS
                  </div>
                  <div
                      className={classnames(
                      "radius-middle p-3 mt-4 mb-4 text-center text-medium-grey cursor-pointer col h6",
                      {
                          active: infUsuModif.tidUser === "6",
                      }
                      )}
                      
                  >
                      CD
                  </div>
                  <div
                      className={classnames(
                      "radius-middle p-3 mt-4 mb-4 text-center text-medium-grey cursor-pointer col h6",
                      {
                          active: infUsuModif.tidUser === "7",
                      }
                      )}
                      
                  >
                      SE
                  </div>
                  <div
                      className={classnames(
                      "radius-middle p-3 mt-4 mb-4 text-center text-medium-grey cursor-pointer col h6",
                      {
                          active: infUsuModif.tidUser === "8",
                      }
                      )}
                      
                  >
                      FI
                  </div>
                  <div
                      className={classnames(
                      "radius-right p-3 mt-4 mb-4 text-center text-medium-grey cursor-pointer col h6",
                      {
                          active: infUsuModif.tidUser === "9",
                      }
                      )}
                      
                  >
                      RCN
                  </div>
              </Row>
                    */}
              <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
                <h1>{listStepLine[0].title}</h1>
              </div>
              <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
                <p>{descripLineaCreacion[0]}</p>
              </div>
              <Row className="m-lg-2 m-xs-0 m-md-0">
                  <div
                      className={classnames(
                      "radius-left p-3 mt-2 mb-2 text-center text-medium-grey cursor-pointer col h5",
                      {
                          active: infUsuModif.isSupervisorUser === "S",
                      }
                      )}
                      
                  >
                      Supervisor
                  </div>
                  <div
                      className={classnames(
                      "radius-right p-3 mt-2 mb-2 text-center text-medium-grey cursor-pointer col h5",
                      {
                          active: infUsuModif.isSupervisorUser === "N",
                      }
                      )}
                      
                  >
                      No Supervisor
                  </div>
              </Row>
                  <div className="inputs-icons-borderbott" style={{height:"43px"}}>
                    <p style={{fontSize:"14px",border:"none", width:"250px",height:"33px",padding:"4px 4px 4px 4px",margin:"0px 0px 0px 0px"}}>{tiduser}</p>
                    <img style={{height:"12px", }} src={IconTid}></img>
                  </div>

                  <InputGroup className="input-group-alternative mt-2 mb-2">
                      <div className="inputs-icons-borderbott">
                          <input
                          className="form-control h5 p-1"
                          placeholder="Documento de Identidad"
                          type="text"
                          value={infUsuModif.nidUser}
                          style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                          />
                          <img style={{height:"12px", }} src={IconNid}></img>
                      </div>
                  </InputGroup>
                  <InputGroup className="input-group-alternative mt-2 mb-2">
                      <div className="inputs-icons-borderbott">
                          <input
                          className="form-control h5 p-1"
                          placeholder="Nombre del cliente"
                          type="text"
                          ref={refModifNombre}
                          onChange={editanombre}
  
                          value={infUsuModif.nameUser}
                          style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                          />
                          <img style={{height:"12px", }} src={IconNom}></img>
                      </div>
                  </InputGroup>
                  <InputGroup className="input-group-alternative  mt-2 mb-2">
                      <div className="inputs-icons-borderbott">
                          <input
                          maxLength={50}
                          required
                          pattern= '[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+[.]{1}[a-zA-Z]{2,}$'
                          className="form-control h5 p-1"
                          placeholder="Correo electronico"
                          type="text"
                          onChange={editacorreo}
                          onInvalid={e => e.target.setCustomValidity('Ingrese un correo válido')}
                          onInput={e => e.target.setCustomValidity('')}
                          value={infUsuModif.emailUser}
                          style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                          />
                          <img style={{height:"12px", }} src={IconCorreo}></img>
                      </div>
                  </InputGroup>
                  <InputGroup className="input-group-alternative  mt-2 mb-3">
                      <div className="inputs-icons-borderbott">
                          <input
                          className="form-control h5 p-1"
                          placeholder="Número de celular"
                          type="text"
                          onChange={editacelular}
  
                          value={infUsuModif.cellNumberUser}
                          style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                          />
                          <img style={{height:"12px", }} src={IconCel}></img>
                      </div>
                  </InputGroup>
                  <button
                      style={{width:"50%"}}
                      className="bg-green text-white btn btn-rounded btn-block btn mb-3 ml-auto mr-auto"
                      onClick={()=>{nextinfbasic()}}
                  >
                      Continuar
                  </button>
              
          </Col>
        )
        break;
      case 1:
        
        return(
          <Col xl="6" lg="8">
            <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                  <button className="btn-icon bg-white text-green btn" onClick={enviacancelacionM}>Cancelar</button>
            </div>
            <div style={{display:"flex",flexDirection:"row", justifyContent:"space-between",alignItems:"center"}}>
              <button onClick={()=>{controlesCreaUsu(indicadoretapa,-1)}} className="btn-icon text-dark-grey btn"><span class="btn-inner--icon">{"<"}</span>Volver</button>
              <button onClick={()=>{controlesCreaUsu(indicadoretapa,1)}} className="btn-icon text-dark-grey btn">Siguiente{" "}<span class="btn-inner--icon">{">"}</span></button>
            </div>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
              <h1>{listStepLine[1].title}</h1>
            </div>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
              <p>{descripLineaCreacion[1]}</p>
            </div>
            <div style={{weight:"100%"}}>
              {perfiles.map(function (item, index) {
                return (
                  <div className="mb-xl-0 cursor-pointer" style={{display:"flex",flexDirection:"row",justifyContent:"left",alignItems:"center", margin:"10px 10px 10px 10px"}}>
                    <Checksantader mensaje={()=>{return(<p><b style={{fontWeight:"bold"}}>{item.nombrePerfil}</b>  {": " + item.descripcion}</p>)} } estadocheck={item.habilitado} idCheck={item.id} funcionpadre={escuchaCheck}></Checksantader>
                  </div>
                );
              })
              }
              <div style={{margin:"10px 10px 10px 10px",width:"50%"}}className="ml-auto mr-auto">
                <button
                  type="submit"
                  className="bg-green text-white btn  btn-rounded btn-block btn"
                  onClick={() => {getProfile();finEdtIps();}}
                >  Continuar
                </button>
              </div>
              
            </div>
          </Col>
        )
        break;
        case 2:
        return(
          <Col xl="6" lg="8">
            <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                  <button className="btn-icon bg-white text-green btn" onClick={enviacancelacionM}>Cancelar</button>
            </div>
            <div style={{display:"flex",flexDirection:"row", justifyContent:"space-between",alignItems:"center"}}>
              <button onClick={()=>{controlesCreaUsu(indicadoretapa,-1)}} className="btn-icon text-dark-grey btn"><span class="btn-inner--icon">{"<"}</span>Volver</button>
              <button onClick={()=>{controlesCreaUsu(indicadoretapa,1)}} className="btn-icon text-dark-grey btn">Siguiente{" "}<span class="btn-inner--icon">{">"}</span></button>
            </div>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
              <h1>{listStepLine[2].title}</h1>
            </div>
          <>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
                <p>{descripLineaCreacion[3]}</p>
            </div>
              <RelatedAccounts
                data={supervisorUsers}
                tab={6}
              ></RelatedAccounts>
          </>
          </Col>
        )
       break
      case 3:
        return(
          <Col xl="6" lg="8">
            <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                <button className="btn-icon bg-white text-green btn" onClick={enviacancelacionM}>Cancelar</button>
            </div>
            <div style={{display:"flex",flexDirection:"row", justifyContent:"space-between",alignItems:"center"}}>
              <button onClick={()=>{controlesCreaUsu(indicadoretapa,-1)}} className="btn-icon text-dark-grey btn"><span class="btn-inner--icon">{"<"}</span>Volver</button>
              {/* <button onClick={()=>{controlesCreaUsu(indicadoretapa,1)}} className="btn-icon text-dark-grey btn">Siguiente{" "}<span class="btn-inner--icon">{">"}</span></button> */}
            </div>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
              <h1>{listStepLine[3].title}</h1>
            </div>
            <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%"}}>
              <p>{descripLineaCreacion[2]}</p>
            </div>
            <div>
              <InputGroup className="input-group-alternative mt-2 mb-2 ml-auto mr-auto" style={{width:"80%"}}>    
                <div className="inputs-icons-borderbott">
                  <input
                    className="form-control p-1"
                    placeholder={"Ip 1"}
                    type="text"
                    value={IpAct}
                    onChange={editaIp}
                    style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                    
                  />
                  {/*<button className="btn bg-green text-white" onClick={()=>{agregaIp()}}>Agregar</button>*/}
                  <BotonEliminaIp eliminarIp={agregaIp} index={0} tipo={"agregar"}></BotonEliminaIp>
                </div>  
                <Alerts data={listAlert}></Alerts>
              </InputGroup>
              {Ips.map((item,index)=>{
                return(
                  <div className="mb-xl-0 ml-auto mr-auto p-1" style={{display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center",borderRadius:"10px",background:"#FFFFFF", margin:"10px 10px 10px 10px",width:"80%"}}>
                    <h1 style={{display:"inline",fontSize:"18px"}}>{item}</h1>
                    {/*<button className="btn-icon bg-white text-green btn" onClick={()=>{eliminaIp(index)}}>Eliminar</button>*/}
                    <BotonEliminaIp  className="cursor-pointer"eliminarIp={eliminaIp} index={index} tipo={"eliminar"}></BotonEliminaIp>
                  </div>
                )
              })}
              <div style={{display:"flex",justifyContent:"center",alignItems:"center", width:"50%", margin:"15px 0px 15px 0px"}}className="ml-auto mr-auto">
                <button onClick={pideotpmodif} className="btn bg-green text-white btn-block">Guardar</button>
              </div>
              <Compotp esperando={cargandootpmodifusu} pideotp={otpmodifusu} funcrespadre={respuestaotpmodifusu} mensaje={"Digita la clave temporal que se te envio para la modificacion del usuario"}></Compotp>

            </div>
            <Alerts data={listAlert}></Alerts>
            
          </Col>
        )
        break;
    
      case 4:
        return(
          <div style={{display:"flex",flexDirection:"column" ,justifyContent:"center",alignItems:"center",borderRadius:"5px",background:"#FFFFFF", margin:"10px 10px 10px 10px", padding:"15px 15px 15px 15px"}}>
            <p>Usuario modificado con exito. ¿Desea modificar permisos en los productos?</p>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-around",alignItems:"center"}}>
              <button onClick={()=>{elecModProd(true)}} className="btn bg-green text-white " >Si</button>
              <button onClick={()=>{elecModProd(false)}} className="btn bg-green text-white " >No</button>
            </div>
          </div>
        )

        break;
      case 5:

        if (listProducts.length > 0) {
          return (
            <div>  
              <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
                <button className="btn-icon bg-white text-green btn" onClick={enviacancelacionM}>Cancelar</button>
              </div> 
            {
              
           
            listProducts.map((item, index)=>{
              return(
                <div>
                  <CardAccount  data={item} index={index}></CardAccount>
                </div>
              )
            
            })
            }
              <div style={{display:"flex",justifyContent:"center", alignItems:"center", margin:"10px 10px 10px 10px"}}>
                <button onClick={()=>{actualizaUsuarioProd()}} className="btn bg-green text-white" style={{width:"50%"}}>Guardar</button>

              </div>
              <Alerts data={listAlert}></Alerts>
              
            </div>
          );
        } else {
          return (
            <Skeleton
              height={100}
              count={4}
              className="card-transaction-info"
              style={{ width: "-webkit-fill-available" }}
            ></Skeleton>
          );
        }

        break;
      case 6:
        /*
        return(
          <OptionsProducts ></OptionsProducts>
        );
        */
        return(<Campoformato esSupervisor = {infUsuModif.isSupervisorUser} data={bodyprodedit} replica={2} salir={salirModifProdPopUp} terminar={saliryguardarmodifPopUp}></Campoformato>)
        break;
      case 10:
        return (
          <div style={{display:"flex",justifyContent:"center", alignItems:"center"}}>
            <Skeleton
              height={50}
              
              count={4}
              className="card-transaction-info"
              style={{ width: "100%" }}
            ></Skeleton>
            {/*mensaje exito*/}
            <Modal
              className="modal-dialog-centered"
              contentClassName=""
              isOpen={exitoModif}
              //toggle={() => setResultModal(!cancelationModal)}
            >
              <div className="p-4">
                <div class="my-modal-header">
                  <img
                    alt="delete-icon"
                    class="my-header-brand-img"
                    src={exitoCreacion}
                  />
                  <div class="header-title">
                    <h5 class="avv-title-bold">Proceso exitoso</h5>
                    <p class="header-subtitle">
                        El usuario fue modificado con éxito.
                    </p>
                  </div>
                </div>
                <div class="my-modal-footer pt-2">
                  <button
                    class="btn bg-green text-white"
                    type="button"
                    onClick={() => {  terminaModifProd()         
                    }}
                  >
                    Continuar
                  </button>
                </div>
              </div>
            </Modal>
            {/*fin mensaje */}
            
          </div>
          
        )

        break;
      default:
        return(
          <div>

          </div>
        )
    }
    
}

export default ComponentemodificaUsu2;